import { render, staticRenderFns } from "./SavedCards.vue?vue&type=template&id=aee5108c&scoped=true&"
import script from "./SavedCards.vue?vue&type=script&lang=js&"
export * from "./SavedCards.vue?vue&type=script&lang=js&"
import style0 from "./SavedCards.vue?vue&type=style&index=0&id=aee5108c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee5108c",
  null
  
)

export default component.exports